import {NgModule} from '@angular/core';

import { MaterialColorPickerModule } from 'app/main/shared/material-color-picker/material-color-picker.module';
import {ColorCellComponent} from './color-cell.component';

@NgModule({
    imports: [
        MaterialColorPickerModule
    ],
    declarations: [
        ColorCellComponent
    ],
    exports: [
        ColorCellComponent
    ]
})
export class ColorCellModule {
}
